import { Spin } from "antd";

const LoadingComponent = () => {
  return <Spin />;
};

export default LoadingComponent;
